import { BasePlot } from './base_plot'
import { select } from 'd3-selection'

export abstract class ScrollingDoubleCanvasPlot extends BasePlot {

  protected ctxA: CanvasRenderingContext2D;
  protected canvasA;
  protected canvasAD3;
  protected ctxB: CanvasRenderingContext2D;
  protected canvasB;
  protected canvasBD3;
  protected svg;
  protected margin = {top: 15, right: 20, bottom: 30, left: 60};
  private newDataBuffer: Array<Array<number>>
  protected shift: number;
  private screenWidth: number;
  private screenHeight: number;

  public constructor(key: string, container: HTMLElement, width: number, height: number, config) {
      super(key, container, width, height);
      if ("colorbar" in config){
        this.margin.right = 100;
      }
      this.makeCanvas();
      this.newDataBuffer = [];
      this.shift = 0;
  }

  private makeCanvas() {

    let containerSel = select(this.container);
    this.screenWidth = this.container.clientWidth - this.margin.left - this.margin.right;
    this.screenHeight = this.container.clientHeight - this.margin.top - this.margin.bottom;

    let clippedContainer = containerSel
      .append('div')
        .style("position", "absolute")
        .style("overflow", "hidden")
        .style('width', this.screenWidth + "px")
        .style('height', this.screenHeight + "px")
        .style('z-index', -1)
        .style('margin-left', this.margin.left + 'px')
        .style('margin-top', this.margin.top + 'px')

    this.canvasAD3 = clippedContainer
        .append('canvas')
        .style('position', 'absolute')
        // .style('margin-left', this.margin.left + 'px')
        // .style('margin-top', this.margin.top + 'px')
        .style('width', this.screenWidth + "px")
        .style('height', this.screenHeight + "px")
        // .style('top', '200px')
        .attr('width', this.width)
        .attr('height', this.height);
    this.canvasA = this.canvasAD3.node();

    this.canvasBD3 = clippedContainer
        .append('canvas')
        .style('position', 'absolute')
        .style('width', this.screenWidth + "px")
        .style('height', this.screenHeight + "px")
        .style('left', this.width+'px')
        // .style('top', '200px')
        .attr('width', this.width)
        .attr('height', this.height);
    this.canvasB = this.canvasBD3.node();

    this.svg = select(this.container)
        .append("svg")
        .attr("width",this.screenWidth+this.margin.left+this.margin.right)
        .attr("height", this.screenHeight+this.margin.top+this.margin.bottom)
        .append("g")
          .attr("transform",
                "translate(" + this.margin.left + "," + this.margin.top + ")");

    this.ctxA = this.canvasA.getContext('2d', {alpha: false});
    this.ctxA.imageSmoothingEnabled = false;
    this.ctxB = this.canvasB.getContext('2d', {alpha: false});
    this.ctxB.imageSmoothingEnabled = false;
    // console.log(this.ctx.getContextAttributes());
  }

  private swapCanvases(){
    [this.ctxA, this.ctxB] = [this.ctxB, this.ctxA];
    [this.canvasA, this.canvasB] = [this.canvasB, this.canvasA];
    [this.canvasAD3, this.canvasBD3] = [this.canvasBD3, this.canvasAD3];
  }
  private shiftCanvasLeft(pixels: number){
    this.shift += pixels;
    if (this.shift >= this.width){
      this.shift -= this.width;
      this.swapCanvases();
    }
    let screenWidth = parseFloat(this.canvasAD3.style("width"))//this.canvasAD3.node().clientWidth;
    let shiftFromRight = this.shift*screenWidth/this.width
    let shiftFromLeft = screenWidth + shiftFromRight - this.screenWidth;
    this.canvasAD3.style('left', (-shiftFromLeft) + "px");
    this.canvasBD3.style('left', (-shiftFromLeft+screenWidth) + "px");
  }

  protected abstract drawNewColumns(data: Array<Array<number>>): void;


  public update(data: Array<Array<number>>): void
  {
    this.newDataBuffer = this.newDataBuffer.concat(data);
  }

  public render(): void
  {
    let numToInsert = this.newDataBuffer.length;
    if (numToInsert > 0)
    {
      let maxToInsert = this.width - this.shift;
      if (numToInsert <= maxToInsert){
        this.drawNewColumns(this.newDataBuffer);
        this.shiftCanvasLeft(this.newDataBuffer.length);
        this.newDataBuffer = [];
      }else{
        if (maxToInsert > 0){
          let tempData = [];
          for(let i = 0; i < maxToInsert; i++){
            tempData.push(this.newDataBuffer.shift());
          }
          this.drawNewColumns(tempData);
          this.shiftCanvasLeft(maxToInsert);
        }
        this.drawNewColumns(this.newDataBuffer);
        this.shiftCanvasLeft(this.newDataBuffer.length);
        this.newDataBuffer = [];
      }
    }
  }
}
